<template>
  <div class="chronicle" style="overflow-x: hidden">
    <Modal
      class="common-drawer newModal chronicle"
      v-model="value"
      title="配置记录"
      width="800"
      :mask-closable="false"
      @on-cancel="closeDrawer"
      class-name="vertical-center-modal"
    >
      <div class="common-list table-margin" style="padding-top:4px !important">
        <div class="title">
          您正在查看网关“{{
            curItemDetail ? curItemDetail.nickName : "-"
          }}”的配置记录
        </div>
        <div class="common-list" >
          <Table
           :height="recordHeight"
            class="equipmentTable"
            :columns="columns1"
            :data="dataLists"
          ></Table>
        </div>
        <div class="common-page fr">
          <Page
            show-total
            show-elevator
            :total="qthrefrom.total"
            @on-page-size-change="getListsSize"
            show-sizer
            :current="qthrefrom.current"
            :page-size="qthrefrom.size"
            @on-change="getrecolist"
          >
          </Page>
        </div>
      </div>
      <div class="drawer-footer" slot="footer">
        <!-- <Button
          type="primary"
          @click="closeDrawer()"
      
          >确定</Button
        > -->
      </div>
      
    </Modal>
  </div>
</template>
<script>
import api  from '@/api'
export default {
  props: ["value", "data1", "curItemDetail"],
  data() {
    return {
      qthrefrom: {
        oilSiteThresholdId: undefined,
        current: 1,
        size: 10,
        total: 0,
      },
      recordHeight:240,
      columns1: [
        {
          title: "配置内容",
          key: "content",
        },
        {
          title: "配置人",
          key: "operatorId",
        },
        {
          title: "时间",
          key: "gmtCreate",
        },
      ],
      dataLists:[],
    };
  },
  watch: {
    value(newvalue) {
     if(newvalue){
      this.qthrefrom.gatewayId=this.curItemDetail.id
      this.$nextTick(()=>{
        this.getrecolist()
      })
     }
    },
  },
  mounted() {
    //this.init();
  },
  methods: {
    getListsSize(size) {
      this.qthrefrom.size = size;
      this.getrecolist(1);
    },
    getrecolist(page=1) {
      if (page) this.qthrefrom.current = page; //分页处理
      console.log('this.qthrefrom',this.qthrefrom)
      api
        .axss("post", "/ocm-oil-site/gateway/detail/log/page", {
          ...this.qthrefrom,
        })
        .then((datas) => {
          if (datas.code == "00000") {
            let data = datas.data;
            this.qthrefrom.total = data.total;
            this.dataLists = data.records;
          }
        });
    },
    init() {
      this.chrcleColumns = [
        {
          title: "日期",
          with: 200,
          key: "gmtCreate",
        },
        {
          title: "内容",
          with: 200,
          key: "content",
        },
      ];
    },
    closeDrawer() {
      this.$emit("input", false);
      this.$nextTick(()=>{
         this.dataLists=[]
      })
    },
  },
};
</script>
  
  <style lang='less' scoped>
::v-deep .ivu-modal-body .ivu-table-wrapper {
  min-height: 100px;
  overflow-y: auto;
}

::v-deep .chronicle .ivu-modal-body {
  overflow-y: auto;
}

.common-page {
  margin-bottom: 0px;
}
</style>
<style >
.chronicle .ivu-table-overflowX {
  overflow-x: hidden !important;
}

.chronicle .ivu-table-default:after {
  content: "";
  width: 100%;
  height: 1px;
  position: absolute;
  left: 0;
  bottom: 0;
  background-color: transparent !important;
  z-index: 4;
}
</style>
<style lang="less" scoped >
.comment {
  white-space: pre-wrap;
}

.mainversion .equipmentTable {
  max-height: none !important;
  overflow-x: hidden !important;
}
.mainversion .ivu-modal-wrap .ivu-modal {
  top: 100px !important ;
}
.title {
  font-size: 14px;
  font-family: PingFang SC-Regular, PingFang SC;
  font-weight: 400;
    color: #999;
 
}
</style>